host.actions.register({
    // #region Vars
    name: '288a.commerce.orderlist.toCart',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tCart = data;
        if (tCart == null) {
            return this.Cancel();
        }
        let tArgs = {
            title: "Bestelliste " + tCart.cartNumber,
            message: "Möchten Sie die Bestellliste wirklich in einen Warenkorb umwandeln?",
            successCallback: async () => {
                //Delete
                await this.$host.api.put(`commerce/order-lists/${tCart.cartID}/change-to-cart`);
                //Store
                this.$store.commit('carts/load');
            }
        };
        return this.Window(await host.notification.showModal2("g-messages-question", tArgs));
    },
    // #endregion
});
export {};
